VLW.controllers.Menu = class extends VLW.controllers.base_mc {
	constructor(a, b) {
		super(a, b);
		broadCaster.INTROMENU.add(this.onIntroDispatch);
		this.menuFull = new VLW.MenuFull(document.querySelector("._menuFull"));
		this.eltByPlacementMouse = {
			"tl": document.querySelector(`[data-code='_heritage']`),
			"tr": document.querySelector(`[data-code='_vins']`),
			"bl": document.querySelector(`[data-code='_hommes']`),
			"br": document.querySelector(`[data-code='_terroir']`),
		};
		this._marginX            = 0;
		this._marginY            = 0;
		this.aLien               = [...this.qsa("a")];
		this.aLien.forEach((elt) => {
			elt.vlwSplitTextTop     = new SplitText(elt.querySelector("._top"), {type: "chars",charsClass:"char"});
			elt.vlwSplitTextBot     = new SplitText(elt.querySelector("._bot"), {type: "chars",charsClass:"char"});
			elt.style.pointerEvents = "none";
			document.body.appendChild(elt);
			elt.addEventListener("click", this.onMouseEltClick);
		});
		this.menuHover    = false;
		this.svgCadrePath = document.querySelector("body>._svgCadre path");
		this.onResize();
		window.addEventListener("resize", this.onResize, supportsPassive);
		window.addEventListener("blur"	, this.onLeaveSite, false);
		window.addEventListener("focus"	, this.onFocusSite, false);
		document.addEventListener("mouseleave", this.onLeaveSite, false);
		document.addEventListener("mouseenter", this.onFocusSite, false);
		[...document.querySelectorAll("._menuHover span")].forEach((elt) => {
			elt.vlwSplitText = new SplitText(elt, {type: "chars"});
			TweenMax.set(elt.vlwSplitText.chars, {opacity: 0});
		});
		broadCaster.PAGE_INTRO_CONTENT.add(this.onHideCadre);
		broadCaster.SITE_LOADURL.add(this.onSiteLoadUrl);
	}
	
	onSiteLoadUrl() {
		if (this.menuHover === true) {
			this.menuHoverLeaveLocked = true;
		}
	}
	
	onHideCadre() {
		this.menuHoverLeaveLocked = false;
		TweenMax.to(this.svgCadrePath, .7, {fillOpacity: 0, delay: .5, ease: Sine.easeIn});
		TweenMax.to(document.querySelector("._menuHover"), .75, {opacity: 0, delay: 0});
	}
	
	onFocusSite(e) {
		TweenMax.killDelayedCallsTo(this.setPixiAppRender);
		this.setPixiAppRender(true);
	}
	setPixiAppRender(renderable){
		PIXIAPP.renderable = renderable;
	}
	
	onLeaveSite(e) {
		TweenMax.delayedCall(10,this.setPixiAppRender,[false],this);
		this.onMouseMenuLeave();
		this.mouseEltLeaveMenuHoverAnim(0, true);
	}
	
	setMouseMoveEventListener() {
		BUREAU_ONLY && window.addEventListener("mousemove", this.onMouseMove, supportsPassive);
	}
	
	onMouseMove(e) {
		PIXIAPP.renderable = true;
		let text_X         = (e.clientX.between(0, this._marginX) || e.clientX.between(windowSize.width -  this._marginX, windowSize.width));
		let text_Y         = (e.clientY.between(0, this._marginY) || e.clientY.between(windowSize.height - this._marginY, windowSize.height));
		let _TopOrBottom   = e.clientY > windowSize.height * .5 ? "b" : "t";
		let _LeftOrright   = e.clientX > windowSize.width * .5 ? "r" : "l";
		(text_X && text_Y) ? this.onMouseEltEnter(_TopOrBottom + _LeftOrright) : this.onMouseEltLeave();
		if (this.menuHover === false) {
			(text_X && text_Y) ? this.onMouseMenuHover(_TopOrBottom + _LeftOrright, {x: e.clientX, y: e.clientY}) : this.onMouseMenuLeave();
		} else {
			(text_X || text_Y) ? this.onMouseMenuHover(_TopOrBottom + _LeftOrright, {x: e.clientX, y: e.clientY}) : this.onMouseMenuLeave();
		}
	}
	
	onMouseEltClick() {
		broadCaster.MENU_CLICK.dispatch();
	}
	
	onMouseMenuLeave() {
		if (this.menuHover === false) {
			return;
		}
		broadCaster.MENU_LEAVE.dispatch();
		this.menuHover = false;
		TweenMax.to(this.svgCadrePath, .7, {fillOpacity: 0, delay: 0, ease: Sine.easeIn});
	}
	
	onMouseMenuHover(placementMouse = "", pMouse) {
		if (this.menuHover === true) {
			return;
		}
		broadCaster.MENU_HOVER.dispatch();
		this.menuHoverLeaveLocked = false;
		this.menuHover            = true;
		TweenMax.killTweensOf(this.svgCadrePath);
		if (this.svgCadrePath.style.fillOpacity === "0" || this.svgCadrePath.style.fillOpacity === "") {
			switch (true) {
				case (placementMouse === "tl"):
					TweenMax.fromTo(this.p1, .75, {ratio: 0}, {ratio: 0, delay: 0, onUpdate: this.onUpdate});
					TweenMax.fromTo(this.p2, .5, {ratio: 1.75}, {ratio: 0, delay: .2, onUpdate: this.onUpdate});
					TweenMax.fromTo(this.p3, .5, {ratio: 1.75}, {ratio: 0, delay: .4, onUpdate: this.onUpdate});
					TweenMax.fromTo(this.p4, .5, {ratio: -1.75}, {ratio: 0, delay: .2, onUpdate: this.onUpdate});
					break;
				case (placementMouse === "tr"):
					TweenMax.fromTo(this.p2, .75, {ratio: 0}, {ratio: 0, delay: 0, onUpdate: this.onUpdate});
					TweenMax.fromTo(this.p3, .5, {ratio: 0.75}, {ratio: 0, delay: .2, onUpdate: this.onUpdate});
					TweenMax.fromTo(this.p4, .5, {ratio: 0.75}, {ratio: 0, delay: .4, onUpdate: this.onUpdate});
					TweenMax.fromTo(this.p1, .5, {ratio: -0.75}, {ratio: 0, delay: .2, onUpdate: this.onUpdate});
					break;
				case (placementMouse === "br"):
					TweenMax.fromTo(this.p3, .75, {ratio: 0}, {ratio: 0, delay: 0, onUpdate: this.onUpdate});
					TweenMax.fromTo(this.p4, .5, {ratio: 0.75}, {ratio: 0, delay: .2, onUpdate: this.onUpdate});
					TweenMax.fromTo(this.p1, .5, {ratio: 0.75}, {ratio: 0, delay: .4, onUpdate: this.onUpdate});
					TweenMax.fromTo(this.p2, .5, {ratio: -0.75}, {ratio: 0, delay: .2, onUpdate: this.onUpdate});
					break;
				case (placementMouse === "bl"):
					TweenMax.fromTo(this.p4, .75, {ratio: 0}, {ratio: 0, delay: 0, onUpdate: this.onUpdate});
					TweenMax.fromTo(this.p1, .5, {ratio: 0.75}, {ratio: 0, delay: .2, onUpdate: this.onUpdate});
					TweenMax.fromTo(this.p2, .5, {ratio: 0.75}, {ratio: 0, delay: .4, onUpdate: this.onUpdate});
					TweenMax.fromTo(this.p3, .5, {ratio: -0.75}, {ratio: 0, delay: .2, onUpdate: this.onUpdate});
					break;
				default:
					TweenMax.fromTo(this.p1, .75, {ratio: -0.5}, {ratio: 0, delay: 0, onUpdate: this.onUpdate});
					TweenMax.fromTo(this.p2, .5, {ratio: 0.75}, {ratio: 0, delay: .2, onUpdate: this.onUpdate});
					TweenMax.fromTo(this.p3, .5, {ratio: 0.75}, {ratio: 0, delay: .4, onUpdate: this.onUpdate});
					TweenMax.fromTo(this.p4, .5, {ratio: -0.75}, {ratio: 0, delay: .2, onUpdate: this.onUpdate});
					break
			}
		}
		
		TweenMax.fromTo(this.svgCadrePath, 1, {fill: 0x635c4e}, {fill: 0x000000, fillOpacity: .75, ease: Sine.easeIn});
	}
	
	setMargin() {
		// this._marginX                                  = 250;
		// this._marginX                                  = 170;
		// this._marginY                                  = 150;
		// this._marginY                                  = 80;
		this._marginX = 5/36*(windowSize.width) - 50/3;
		this._marginY = 7/48*(windowSize.height) -15/2;
		
	}
	
	onResize() {
		PIXIAPP.renderable = true;
		let dW  = getDocSize().width;
		let dH  = getDocSize().height;
		this.p1 = {x: 100, y: 100, delta: 50, ratio: 0};
		this.p2 = {x: dW - 100, y: 100, delta: 50, ratio: 0};
		this.p3 = {x: dW - 100, y: dH - 100, delta: 50, ratio: 0};
		this.p4 = {x: 100, y: dH - 100, delta: 50, ratio: 0};
		this.drawSVGCadre();
		this.setMargin();
		
	}
	
	drawSVGCadre() {
		let dW    = getDocSize().width;
		let dH    = getDocSize().height;
		let aPath = [
			"M", 0, 0,
			"h", dW,
			"v", dH,
			"h", dW * -1,
			"v", dH * -1,
			"M", this.p1.x + this.p1.delta * this.p1.ratio, this.p1.y + this.p1.delta * this.p1.ratio,
			"L", this.p2.x + this.p2.delta * this.p2.ratio, this.p2.y + this.p2.delta * this.p2.ratio,
			"L", this.p3.x + this.p3.delta * this.p3.ratio, this.p3.y + this.p3.delta * this.p3.ratio,
			"L", this.p4.x + this.p4.delta * this.p4.ratio, this.p4.y + this.p4.delta * this.p4.ratio,
			"Z",
		];
		this.svgCadrePath.setAttribute("d", aPath.join(" "));
	}
	
	onMouseEltLeave() {
		Object.values(this.eltByPlacementMouse).forEach((elt) => elt.hover = false);
		this.mouseEltLeaveMenuHoverAnim();
	}
	
	mouseEltLeaveMenuHoverAnim(delay = 0, force = false) {
		if (force === true || (!window.site.isLoading && this.menuHoverLeaveLocked !== true && this.menuHover === true)) {
			TweenMax.to(document.querySelector("._menuHover"), 1, {opacity: 0, delay: delay});
		}
	}
	
	onMouseEltEnter(placementMouse) {
		let elt = this.eltByPlacementMouse[placementMouse];
		if (elt.hover === true) {
			return '';
		}
		elt.hover = true;
		if (elt.tlIntro) {
			elt.tlIntro.stop();
			elt.tlIntro = null;
			TweenMax.set([...elt.vlwSplitTextTop.chars, ...elt.vlwSplitTextBot.chars], {rotationY: 0, opacity: 1, y: 0, x: 0, color: "#ffffff"});
		}
		
		TweenMax.staggerFromTo(elt.vlwSplitTextTop.chars, .35, {color: "#ffffff", opacity: 1, skewX: 0}, {color: "#C21735", transformOrigin: "50% 50%", opacity: 1, skewX: 15, yoyo: true, repeat: 1, repeatDelay: .25, ease: Sine.easeOut}, .045);
		TweenMax.staggerFromTo(elt.vlwSplitTextBot.chars.slice().reverse(), .35, {color: "#ffffff", opacity: 1}, {color: "#C21735", transformOrigin: "50% 50%", opacity: 1, delay: .25, yoyo: true, repeatDelay: .25, repeat: 1, ease: Sine.easeOut}, .045);
		/***************************************************/
		[...document.querySelectorAll("._menuHover span")].forEach((elt) => {
			TweenMax.set(elt.vlwSplitText.chars, {opacity: 0});
		});
		let _c = elt.getAttribute("data-code");
		let _o = document.querySelector("._menuHover");
		let _e = document.querySelector("._menuHover ." + _c);
		TweenMax.to(_o, .75, {opacity: 1});
		TweenMax.to(_e, .75, {opacity: 1});
		TweenMax.staggerFromTo(_e.vlwSplitText.chars, 1.5, {opacity: 0}, {opacity: 1, ease: Sine.easeOut}, .05);
		TweenMax.staggerFromTo(_e.vlwSplitText.chars, 1.25, {opacity: 0, skewX: 0, skewY: -5, x: -20, y: -0, transformOrigin: "0% 50%", transformPerspective: 1000, rotationX: 0 * 5, rotationY: 20, scale: 1.15}, {skewX: 0, skewY: 0, scale: 1, x: 0, y: 0, rotationX: 0, rotationY: 0, ease: Sine.easeOut}, .05);
		//TweenMax.staggerFromTo(_e.vlwSplitText.chars,3,{color:"#fff"}	,{color:"#000",ease:Sine.easeOut},.15);
	}
	
	onUpdate() {
		this.drawSVGCadre();
	}
	
	onIntroDispatch() {
		let doTween = (elts, delatX = 0, deltaY = 0) => {
			TweenMax.staggerFromTo(elts, 1.5, {opacity: 0}, {opacity: 1, ease: Power2.easeIn}, .1);
			TweenMax.staggerFromTo(elts, 1.5, {
				scale: 1, cycle: {
					x: (i) => {return (10 * delatX);},
					y: (i) => {return (15 * deltaY);}
				}
			}, {x: 0, y: 0, scale: 1, ease: Sine.easeInOut}, .1);
		};
		this.aLien.forEach((elt) => {
			elt.style.pointerEvents = "auto";
			doTween(elt.vlwSplitTextTop.chars, 4, -1);
			doTween(elt.vlwSplitTextBot.chars.reverse(), -4, 1);
			elt.vlwSplitTextBot.chars.reverse();
			elt.tlIntro = new TimelineMax({delay: 3.85 * (1 / CONFIG.INTRO_TIMESCALE)});
			elt.tlIntro.addLabel("start");
			elt.tlIntro.staggerTo(elt.vlwSplitTextTop.chars, .5, {transformOrigin: "50% 50%", x: 5, y: -10, rotationY: 90, opacity: 0, ease: Sine.easeIn}, .05, "start");
			elt.tlIntro.staggerTo(elt.vlwSplitTextBot.chars, .5, {transformOrigin: "50% 50%", x: -5, y: 0, rotationY: 90, opacity: 0, ease: Sine.easeIn}, .05, "start+=.1");
			elt.tlIntro.set(elt.vlwSplitTextTop.chars, {rotationY: -90, y: 0, x: -5, color: "#ffffff"});
			elt.tlIntro.set(elt.vlwSplitTextBot.chars, {rotationY: -90, y: 0, x: 5, color: "#ffffff"});
			elt.tlIntro.addLabel("back");
			elt.tlIntro.staggerTo(elt.vlwSplitTextTop.chars, .5, {transformOrigin: "50% 50%", y: 0, x: 0, rotationY: 0, opacity: 1, ease: Sine.easeOut}, .025, "back");
			elt.tlIntro.staggerTo(elt.vlwSplitTextBot.chars, .5, {transformOrigin: "50% 50%", y: 0, x: 0, rotationY: 0, opacity: 1, ease: Sine.easeOut}, .025, "back+=.05");
		});
		TweenMax.delayedCall(5 * (1 / CONFIG.INTRO_TIMESCALE), this.setMouseMoveEventListener);
		broadCaster.INTROMENU.remove(this.onIntroDispatch);
	}
	
	onUpdateLetter(a, b) {
	}
};